import React from 'react';
import { format } from 'date-fns';

import { IBlogPostFields } from '../../../../types/contentful';

import { getImageData } from '../../../utils/contentful';

import { BlockContainer, Layout, Column } from '../../Layout';
import { Text } from '../../Text';
import { Box } from '../../Box';
import { Breadcrumbs } from '../../Breadcrumbs';

import {
  ImageWrapper,
  HeroImage,
  BlogTextContainer,
  DisclaimerColumn
} from './styles';

interface BlogPostHeroProps extends IBlogPostFields {
  sysId?: string;
}

export function BlogPostHero({
  title,
  heroImage,
  heroImageDisclaimer,
  publishDate,
  sysId
}: BlogPostHeroProps) {
  return (
    <BlockContainer
      data-eltype="blog-post-hero"
      data-blockid={sysId}
      marginBottom={{ 0: 'ml', tablet: 'l', desktop: 'xl' }}
      revealOnScroll={false}
      data-testid="blog-post-hero"
    >
      <Layout gutter={{ 0: 'sm', tablet: 'm', desktop: 'l', max: 'xl' }}>
        <Column size={{ 0: 12, tablet: 12 }} className="mb-4 mt-4">
          <Breadcrumbs pageTitle={title} />
        </Column>
        <Column size={{ 0: 12, tablet: 7 }} order={1}>
          <ImageWrapper>
            <HeroImage
              {...getImageData(heroImage)}
              heroImage={true}
              loading="eager"
              width={630}
              height={630}
              layout="responsive"
              objectFit="cover"
              objectPosition="50% 50%"
            />
          </ImageWrapper>
        </Column>
        <Column size={{ 0: 12, tablet: 5 }} order={3}>
          <BlogTextContainer
            backgroundColor="blogPostHeroBg"
            borderRadius={{ 0: 'blogHero_0', desktop: 'blogHero_desktop' }}
            padding={{ 0: ['xl', 'ml'] }}
            flexDirection="column"
            justifyContent="center"
          >
            <Box marginBottom={{ 0: 'xs', tablet: 's', desktop: 'ml' }}>
              <Text
                textAlign="center"
                fontSize={{ 0: 'm' }}
                colour="defaultText"
              >
                {format(new Date(publishDate), 'MMM d, yyyy')}
              </Text>
            </Box>
            <Text
              as="h1"
              fontSize={{
                0: 'blogTitle_0',
                tablet: 'blogTitle_tablet',
                desktop: 'blogTitle_desktop'
              }}
              fontWeight="500"
              textAlign="center"
              colour="defaultText"
              data-testid="blog-title"
            >
              {title}
            </Text>
          </BlogTextContainer>
        </Column>
        {heroImageDisclaimer && (
          <>
            <DisclaimerColumn
              size={{ 0: 12, tablet: 7 }}
              paddingTop={{ desktop: '2xs' }}
              paddingLeft={{ 0: 'xl', tablet: '2xl', desktop: '3xl' }}
              paddingRight={{ 0: 'xl', tablet: '2xl', desktop: '3xl' }}
              paddingBottom={{ 0: 'm', tablet: 's', desktop: 'm' }}
            >
              <Text fontSize={{ 0: 'xs', tablet: 's' }} fontStyle="italic">
                {heroImageDisclaimer}
              </Text>
            </DisclaimerColumn>
            <Column size={{ 0: 0, tablet: 5 }} order={5} />
          </>
        )}
      </Layout>
    </BlockContainer>
  );
}
